module.exports = __webpack_public_path__ + "img/hr-branch-particle-10.41a9aae8.png";